import styles from "./TimestampCell.module.css";

/**
 * Class for a timestamp column's `cellClass` so the stacked date/time centers
 * vertically — AG Grid's default cell won't center a multi-line block.
 */
export const timestampCellClass = styles.cell;
